import Dashboard from "./Dashboard";
import { DashboardOutorgaContextProvider } from "../../../contexts/DashboardOutorga";
import { Switch } from "react-router-dom/cjs/react-router-dom";
import PrivateRoute from "../../PrivateRoute";

function DashboardView() {
    return (
        <DashboardOutorgaContextProvider>
            <Switch>
                <PrivateRoute exact path="/ambiental/dashboard" component={Dashboard} />
            </Switch>
        </DashboardOutorgaContextProvider>
    );
}

export default DashboardView;